export const AI_SAMPLES = {
  adCopy: {
    en: {
      headline: "Launch Ads in Minutes, Not Days",
      body: "AdKavi writes your copy, generates images, and launches campaigns on Meta and TikTok — all with AI.",
      cta: "Start Free Trial",
    },
    es: {
      headline: "Lanza anuncios en minutos",
      body: "AdKavi escribe tu contenido, crea imágenes y lanza campañas en Meta y TikTok — con inteligencia artificial.",
      cta: "Prueba Gratis",
    },
  },
  images: [] as string[],
  heygenVideoUrl: "",
  elevenLabsAudio: "",
  elevenLabsMime: "audio/mpeg" as const,
};
